module.exports = __webpack_public_path__ + "img/game-b.a5f4f377.svg";